import api from './api.js';

const AGENT_QUEUE_OPTIONS = ['urdu-q', 'english-q', 'sindhi-q', 'punjabi-q'];
const ADMIN_REQUEST_TIMEOUT_MS = 15000;
const ADMIN_REQUEST_CONFIG = { timeout: ADMIN_REQUEST_TIMEOUT_MS };

const normalizeQueueName = (value) => {
  const values = Array.isArray(value) ? value : String(value || '').split(',');
  return Array.from(new Set(
    values
      .map((queueName) => String(queueName || '').trim())
      .filter((queueName) => AGENT_QUEUE_OPTIONS.includes(queueName))
  )).join(',');
};

const normalizeUserPayload = (form = {}) => {
  const extension = form.extension || {};
  const payload = {
    loginName: String(form.loginName || '').trim(),
    fullName: String(form.fullName || '').trim(),
    emailAddress: String(form.emailAddress || '').trim() || null,
    phoneNo: String(form.phoneNo || '').trim() || null,
    mobileNo: String(form.mobileNo || '').trim() || null,
    departmentId: Number(form.departmentId || 0),
    roleIds: Array.isArray(form.roleIds) ? form.roleIds.map(Number).filter(Boolean) : [],
    isActive: Boolean(form.isActive),
    extension: {
      extensionNumber: String(extension.extensionNumber || '').trim(),
      sipUsername: String(extension.sipUsername || '').trim(),
      sipPassword: String(extension.sipPassword || '').trim(),
      queueName: normalizeQueueName(extension.queueName),
      isEnabled: Boolean(extension.isEnabled),
    },
  };

  const password = String(form.password || '').trim();
  if (password) {
    payload.password = password;
  }

  return payload;
};

export const fetchAdminUsers = async () => {
  const response = await api.get('/admin/users', ADMIN_REQUEST_CONFIG);
  return Array.isArray(response?.data?.data) ? response.data.data : [];
};

export const fetchAdminDepartments = async () => {
  const response = await api.get('/admin/departments', ADMIN_REQUEST_CONFIG);
  return Array.isArray(response?.data?.data) ? response.data.data : [];
};

export const fetchAdminRoles = async () => {
  const response = await api.get('/admin/roles', ADMIN_REQUEST_CONFIG);
  return Array.isArray(response?.data?.data) ? response.data.data : [];
};

export const createAdminUser = async (form) => {
  const response = await api.post('/admin/users', normalizeUserPayload(form));
  return response?.data?.user || response?.data;
};

export const updateAdminUser = async (userId, form) => {
  const response = await api.put(`/admin/users/${userId}`, normalizeUserPayload(form));
  return response?.data?.user || response?.data;
};

const adminUsersService = {
  fetchAdminUsers,
  fetchAdminDepartments,
  fetchAdminRoles,
  createAdminUser,
  updateAdminUser,
};

export default adminUsersService;
